module.exports = __webpack_public_path__ + "static/img/setting_active.9f80e16e.svg";